import { EventsByClassificationCount } from '@ketch-com/windlass/dist/dataSentry/v1/events/events'
import { PieChartDataItem, PieChartSubCategory } from '../components/DataPieChart'

const colorPalette = ['#15005A', '#1463BB', '#3EB3CD', '#D1E0ED', '#B1BFFF', '#d2baff']

const getColorByIndex = (index: number): string => {
  return colorPalette[index % colorPalette.length]
}

export const transformPieChartData = (data: EventsByClassificationCount[]): PieChartDataItem[] => {
  if (!data?.length) return []

  const TOP_CATEGORIES_COUNT = 5

  // Reduce to only valid items and track total
  let total = 0
  const processed: { name: string; count: number }[] = []

  data.forEach(item => {
    const name = item.classification?.name
    const count = item.count

    if (name && typeof count === 'number' && count > 0) {
      processed.push({ name, count })
      total += count
    }
  })

  if (processed.length === 0 || total === 0) return []

  // Sort by count descending
  const sorted = processed.sort((a, b) => b.count - a.count)

  const mainCategories: PieChartDataItem[] = []
  const othersGroup: { name: string; count: number }[] = []

  sorted.forEach((item, index) => {
    if (index < TOP_CATEGORIES_COUNT) {
      mainCategories.push({
        name: item.name,
        value: Number(((item.count / total) * 100).toFixed(1)),
        color: getColorByIndex(index),
        originalCount: item.count,
      })
    } else {
      othersGroup.push(item)
    }
  })

  if (othersGroup.length > 0) {
    const othersTotal = othersGroup.reduce((sum, item) => sum + item.count, 0)
    const othersPercentage = (othersTotal / total) * 100

    const subCategories: PieChartSubCategory[] = othersGroup.map(item => ({
      name: item.name,
      count: item.count,
      percentage: Number(((item.count / total) * 100).toFixed(1)),
    }))

    mainCategories.push({
      name: 'Others',
      value: Number(othersPercentage.toFixed(1)),
      color: getColorByIndex(mainCategories.length),
      originalCount: othersTotal,
      subCategories,
    })
  }

  return mainCategories
}

export const formatToK = (value: number) => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`
  }
  return value.toString()
}
